<template>
  <v-dialog
      v-model="dialog"
      persistent
      width="500"
  >
    <v-card>
      <v-card-title
          class="headline green darken-2 white--text"
          primary-title
      >
        {{dialogTitle}} Tipologia
      </v-card-title>

      <v-card-text>

        <v-form
            ref="form"
            v-model="valid"
        >
          <v-container>
            <v-layout>
              <v-flex xs4>
                <v-text-field
                    v-model="code"
                    :rules="requiredRules"
                    label="Código"
                    required
                />
              </v-flex>
              <v-flex xs8>
                <v-text-field
                    v-model="name"
                    :rules="requiredRules"
                    label="Nome"
                    required
                />
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs8>
                <v-checkbox
                    :checked="old"
                    v-model="old"
                    label="É uma Tipologia antiga?"
                    required
                />
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs8>
                <v-checkbox
                    v-model="selectable"
                    label="É uma Tipologia selecionável?"
                    required
                />
              </v-flex>
            </v-layout>
            <div v-if="selectable">
              <v-layout>
                <v-flex xs12>
                  <v-autocomplete
                      v-model="degrading_potential_id"
                      label="Potencial Degradador de acordo com a resolução CEPRAM 10/2018"
                      :items="degradingPotentials"
                      item-text="name"
                      item-value="id"
                  />

                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs12>
                  <v-text-field
                      v-model="degrading_potential_for_tax_name"
                      label="Nome do Parâmetro para o Potencial Degradador"
                      required/>

                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs12>
                  <v-text-field
                      v-model=typology_size_for_tax_name
                      label="Nome do Parâmetro para o Porte"
                      required
                  />

                </v-flex>
              </v-layout>
            </div>

          </v-container>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-layout justify-center>
          <v-btn
              :disabled="loading"
              flat
              @click="closeDialog()"
          >
            Cancelar
          </v-btn>

          <v-btn
              color="primary"
              flat
              :loading="loading"
              :disabled="!valid"
              @click="save()"
          >
            Salvar
          </v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

  import DegradingPotentialService from '@/services/applications/configurations/DegradingPotentialService';
  import TypologyService from "@/services/applications/configurations/TypologyService";

  export default {
    name: 'CreateOrUpdateTypology',
    props: ['typology', 'mode', 'dialog'],
    components: {},
    mounted() {
      DegradingPotentialService
        .fetchDegradingPotential()
        .then((response) => {
          this.degradingPotentials = response.data;
        });
    },
    data() {
      return {
        code: '',
        name: '',
        old: false,
        selectable: false,
        degrading_potential_id: null,
        degrading_potential_for_tax_name: '',
        typology_size_for_tax_name: '',
        typology_id: '',
        degradingPotentials: [],

        loading: false,
        requiredRules: [
          v => !!v || 'Campo Obrigatório',
        ],
        valid: false,

      };
    },
    methods: {
      save() {
        const payload = {
          id: this.id,
          code: this.code,
          name: this.name,
          old: this.old,
          selectable: this.selectable,
          degrading_potential_id: this.degrading_potential_id,
          degrading_potential_for_tax_name: this.degrading_potential_for_tax_name,
          typology_size_for_tax_name: this.typology_size_for_tax_name
        };
        TypologyService
          .createOrUpdate(payload)
          .then(() => {
            this.$emit('loadPage');
            this.$store.dispatch('toggleSnackbar', {
              show: true,
              color: 'success',
              message: `Tipologia ${ this.snackBarMode } com sucesso`,
              messageIcon: 'mdi-check',
            });
            this.closeDialog();
          })
          .catch(({ response }) => {
            this.$store.dispatch('toggleSnackbar', {
              show: true,
              color: 'error',
              message: response.data.join(', '),
              messageIcon: 'mdi-alert-circle',
            });
          });
      },
      closeDialog() {
        this.$emit('closeDialog');
      },
    },
    computed: {
      dialogTitle() {
        return this.mode === 'create' ? 'Cadastrar' : 'Editar';
      },
      snackBarMode() {
        return this.mode === 'create' ? 'criado' : 'atualizado';
      },
    },
    watch: {
      dialog(newValue) {
        if (newValue) {
          if (this.typology !== null) {
            this.id = this.typology.id;
            this.code = this.typology.code;
            this.name = this.typology.name;
            this.old = this.typology.old;
            this.selectable = this.typology.selectable;
            this.degrading_potential_id = this.typology.degrading_potential_id;
            this.degrading_potential_for_tax_name = this.typology.degrading_potential_for_tax_name;
            this.typology_size_for_tax_name = this.typology.typology_size_for_tax_name;
            this.typology_id = this.typology.typology_id;
          }
        } else {
          this.$refs.form.reset();
        }
      },
    },
  };
</script>

<style scoped lang="scss">
</style>
